import "./Testimonials.css";
import { useState } from 'react';

const Testimonials = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "How to use the Ideal Weight Calculator?",
      answer: "Here are the steps to use the BMI Calculator:\n1. Enter your height in feet.\n2. Enter your height in inches.\n3. Enter your current weight."
    },
    {
      question: "Does our Ideal BMI Calculator also provide diet plans?",
      answer: "Yes, our ideal weight calculator also provides users a best diet plan, including a meal plan and exercise."
    },
    {
      question: "Does this tool also calculate BMI for children, adults, and the elderly?",
      answer: "Yes. And also provides a healthy diet plan for every age according to their weight and height."
    },
    {
      question: "Is This Tool Totally Free?",
      answer: "Yes, this tool is totally free for all users."
    }
  ];

  return (
    <section className="testimonials-section py-5">
      <div className="container">
        <div className="bmi-info-card">
          <h2 className="info-title">What Is A BMI Calculator Tool?</h2>
          <p className="info-text">
            BMI (Body Mass Index) is a measurement that shows if someone is underweight, overweight, at a healthy weight, or obese based on their height and body weight. Basically, it's useful to check if a person's weight is healthy according to their height. Even though the BMI calculator works on an accurate formula but might not always be perfect, it's still helpful because it lets you know that your body needs attention from a health advisor.
          </p>
          <p className="info-text">
            The meaning of BMI numbers can vary by age and region. It is a good practice for your health to check your BMI once in a while. Gym trainers always recommend everyone check their BMI before starting a workout at the gym because it helps them to understand the right direction. It also helps them to show their maximum output with time.
          </p>
          <p className="info-text">
            Our Ideal Weight Calculator is the best because it also provides you with the best diet plan, including meals and exercise, according to your BMI value. Before, if a user calculated their BMI and also wanted to know what meal plan or exercise they should follow, they had to visit two different websites, one for BMI calculation and a second for the diet plan. But now HealthWibes has overcome this issue, and users can easily know their BMI and get the best diet plan accordingly. This suggests users diet plans based on their different heights and weights.
          </p>
          <p className="info-text">
            This tool allows you to calculate the BMI of any age and weight. It will accurately tell you the BMI of a child, adult, and elderly person, then suggest the best diet plan for them, including meal and exercise plans. It totally depends on users if they want to proceed with a meal plan only or also want an exercise plan. Our mission is to always provide you with fast suggestions that can lead you to a healthy lifestyle.
          </p>

          {/* FAQ Section */}
          <div className="faq-section mt-4">
            <h3 className="faq-title">Frequently Asked Questions</h3>
            {faqs.map((faq, index) => (
              <div className="faq-item" key={index}>
                <button 
                  className={`faq-question ${activeIndex === index ? 'active' : ''}`}
                  onClick={() => toggleFAQ(index)}
                >
                  {faq.question}
                  <span className="toggle-icon">{activeIndex === index ? '−' : '+'}</span>
                </button>
                <div className={`faq-answer ${activeIndex === index ? 'show' : ''}`}>
                  {faq.answer.split('\n').map((paragraph, i) => (
                    <p key={i}>{paragraph}</p>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;